import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Alert } from 'reactstrap';

import { createProductRequest, updateProductRequest, getProductsRequest, createVariationRequest, updateVariationRequest, deleteVariationRequest, 
    createOptionRequest, updateOptionRequest, deleteOptionRequest, updateInventoryRequest } from '../../../actions/products'
import { loadProductStripeTaxCodeRequest, saveProductStripeTaxCodeRequest } from '../../../actions/settings'

import { mockProduct, mockVariation, mockOption, mockFeeOptions } from '../../../model/mockProduct';
import { IMAGE_PRESETS, processImageFileInput, revokeImagePreviewUrl } from '../../../utils/imageUtils';
import { toast } from 'react-toastify';
import { withTranslation } from '../../../i18n/LanguageContext';
import s from './ProductEdit.module.scss';

function WarningBanner() {
    
    return (
      <div >
        Warning!
      </div>
    );
 }

class ProductEdit extends React.Component {
    
    static propTypes = {
        products: PropTypes.array,
        dispatch: PropTypes.func.isRequired,
    };

    static defaultProps = {
        products: []
    };

    state = {
        // curProduct: {
        //     ProductId: 0,
        //     CategoryId: 2,
        //     Name: "",
        //     Description: "",
        //     SKU: "",
        //     Barcode: "",
        //     Price: 0,
        //     FeeOption: 1,
        //     TaxRate: 0,
        //     Picture: null,
        //     Variations: [],
        //     Options:[]
        // },
        curProduct: {...mockProduct},
        prodError: "",
        variationError: "",
        optionError: "",
        inventoryError: "",
        picFile: null,
        tempPicture: "",
        isVariations: false,
        isOptions: false,
        isInventory: false,
        stripeTaxCode: '',
        stripeTaxPresets: {
            food: 'txcd_40060003',
            alcohol: 'txcd_40040000',
            merchandise: 'txcd_99999999',
            inherit: 'txcd_40060003',
        },
    };

    constructor() {
        super();

        this.changeName = this.changeName.bind(this);
        this.changePrice = this.changePrice.bind(this);
        this.changeSku = this.changeSku.bind(this);
        this.changeTax = this.changeTax.bind(this);
        this.changeDescription = this.changeDescription.bind(this);
        this.changeCategory = this.changeCategory.bind(this);
        this.changeFee = this.changeFee.bind(this);
        this.changePicture = this.changePicture.bind(this);
        this.changeStock = this.changeStock.bind(this);
        this.changeVariations = this.changeVariations.bind(this);
        this.changeOptions = this.changeOptions.bind(this);
        this.changeInventory = this.changeInventory.bind(this);
    }

    componentDidMount() {
        if (this.props.curProductId != 0) {
            this.setCurProduct(this.props.curProductId);
        }/* else if (this.props.categories.length > 0) {
            console.log("mount category")
            var curProduct = this.state.curProduct;
            curProduct.CategoryId = this.props.categories[0].CategoryId;
            this.setState({curProduct: curProduct});
        } */
        else {
            const {productDefaults, categories} = this.props;

            const prod = {...mockProduct};
            prod.Name = productDefaults.CustomName;
            
            // Validate that productDefaults.Category exists in categories
            // If not, default to the first category
            const defaultCategoryExists = categories.some(cat => cat.CategoryId === productDefaults.Category);
            if (defaultCategoryExists) {
                prod.CategoryId = productDefaults.Category;
            } else if (categories.length > 0) {
                prod.CategoryId = categories[0].CategoryId;
            }
            
            prod.FeeOption = productDefaults.FeeOption;
            prod.TaxRate = productDefaults.TaxRate * 100;
            
            this.setState({curProduct: prod});
        }

        if (this.props.products.length < 1 && this.props.merchant?.MerchantId) {
            this.props.dispatch(getProductsRequest(this.props.merchant.MerchantId));
        } 
    }

    componentDidUpdate(prevProps) {
        const {curProductId, productDefaults, categories, products} = this.props;

        if (prevProps.merchant?.MerchantId !== this.props.merchant?.MerchantId && products.length < 1 && this.props.merchant?.MerchantId) {
            this.props.dispatch(getProductsRequest(this.props.merchant.MerchantId));
        }

        // Handle when curProductId changes without component remount
        if (curProductId !== prevProps.curProductId) {
            if (curProductId != 0) {
                this.setCurProduct(curProductId);
            } else {
                const prod = {...mockProduct};
                prod.Name = productDefaults.CustomName;
                const defaultCategoryExists = categories.some(cat => cat.CategoryId === productDefaults.Category);
                if (defaultCategoryExists) {
                    prod.CategoryId = productDefaults.Category;
                } else if (categories.length > 0) {
                    prod.CategoryId = categories[0].CategoryId;
                }
                prod.FeeOption = productDefaults.FeeOption;
                prod.TaxRate = productDefaults.TaxRate * 100;
                this.setState({curProduct: prod, isVariations: false, isOptions: false, isInventory: false});
            }
        }

        // Handle when products load after mount (existing product not yet loaded)
        if (products !== prevProps.products && curProductId != 0) {
            const currentProduct = this.state.curProduct;
            if (currentProduct.ProductId === 0 || currentProduct.ProductId !== curProductId) {
                this.setCurProduct(curProductId);
            }
        }

        if (productDefaults !== prevProps.productDefaults) {
            if (curProductId == 0) {
                const prod = {...mockProduct};
                prod.Name = productDefaults.CustomName;
                
                // Validate that productDefaults.Category exists in categories
                // If not, default to the first category
                const defaultCategoryExists = categories.some(cat => cat.CategoryId === productDefaults.Category);
                if (defaultCategoryExists) {
                    prod.CategoryId = productDefaults.Category;
                } else if (categories.length > 0) {
                    prod.CategoryId = categories[0].CategoryId;
                }
                
                prod.FeeOption = productDefaults.FeeOption;
                prod.TaxRate = productDefaults.TaxRate * 100;
                
                this.setState({curProduct: prod});
            }
        }
        
        // Handle case when categories load after mount and current CategoryId is invalid
        if (categories !== prevProps.categories && categories.length > 0 && curProductId == 0) {
            const {curProduct} = this.state;
            const categoryIsValid = categories.some(cat => cat.CategoryId === curProduct.CategoryId);
            if (!categoryIsValid) {
                const updatedProduct = {...curProduct};
                updatedProduct.CategoryId = categories[0].CategoryId;
                this.setState({curProduct: updatedProduct});
            }
        }
    }

    // static getDerivedStateFromProps(props, state) {
    //     if (props.curProductId !== state.prevPropsUserID) {
    //         return {
    //             prevPropsUserID: props.userID,
    //             email: props.defaultEmail
    //         };
    //     }

    //     console.log("derived");
    //     return null;
    // }

    setCurProduct = (productId) => {
        const product = this.getProductById(productId);

        // If getProductById returned mockProduct (products not loaded yet), skip
        if (product.ProductId === 0 && productId != 0) return;

        const isVariations = product.Variations.length > 0 ? true : false;
        const isOptions = product.Options.length > 0 ? true : false;
        const hasVariationStock = (product.Variations || []).some(v => (v.Inventory || 0) != 0);
        const hasTrackedOption = (product.Options || []).some(o => o.TrackInventory);
        const hasVariations = (product.Variations || []).length > 0;
        const isInventory = !!product.TrackInventory || product.Inventory != 0 || hasVariationStock || hasTrackedOption || hasVariations;
        const displayProduct = {...product, TaxRate: product.TaxRate * 100};
        this.setState({curProduct: displayProduct, isVariations: isVariations, isOptions: isOptions, isInventory: isInventory});
        this.loadProductStripeTaxCode(productId);
    }

    loadProductStripeTaxCode = async (productId) => {
        if (!productId || productId == 0) {
            this.setState({ stripeTaxCode: '' });
            return;
        }

        const data = await this.props.dispatch(loadProductStripeTaxCodeRequest(productId));
        if (!data) {
            return;
        }

        const presets = data.presets || {};
        this.setState({
            stripeTaxCode: data.isOverride ? (data.taxCode || '') : '',
            stripeTaxPresets: {
                food: presets.food || 'txcd_40060003',
                alcohol: presets.alcohol || 'txcd_40040000',
                merchandise: presets.merchandise || 'txcd_99999999',
                inherit: presets.inherit || 'txcd_40060003',
            },
        });
    }

    changeStripeTaxCode = (event) => {
        this.setState({ stripeTaxCode: event.target.value });
    }

    changeName(event) {
        var curProduct = this.state.curProduct;
        curProduct.Name = event.target.value;
        this.setState({ curProduct: curProduct });
    }

    changePrice(event) {
        var curProduct = this.state.curProduct;
        curProduct.Price = event.target.value;
        this.setState({ curProduct: curProduct });
    }

    changeSku(event) {
        var curProduct = this.state.curProduct;
        curProduct.SKU = event.target.value;
        this.setState({ curProduct: curProduct });
    }

    changeTax(event) {
        var curProduct = this.state.curProduct;
        curProduct.TaxRate = event.target.value;
        this.setState({ curProduct: curProduct });
    }

    changeDescription(event) {
        var curProduct = this.state.curProduct;
        curProduct.Description = event.target.value;
        this.setState({ curProduct: curProduct });
    }

    changeCategory(event) {
        var curProduct = this.state.curProduct;
        curProduct.CategoryId = parseInt(event.target.value, 10);
        this.setState({ curProduct: curProduct });
    }

    changeFee(event) {
        var curProduct = this.state.curProduct;
        curProduct.FeeOption = event.target.value;
        this.setState({ curProduct: curProduct });
    }

    changeInternalOnly = (event) => {
        const curProduct = this.state.curProduct;
        curProduct.InternalOnly = event.target.checked;
        this.setState({ curProduct });
    }

    async changePicture(event) {
        const input = event.target;
        const file = input.files && input.files[0];

        if (!file) {
            revokeImagePreviewUrl(this.state.tempPicture);
            this.setState({ picFile: null, tempPicture: "" });
            return;
        }

        try {
            const result = await processImageFileInput(
                file,
                this.state.tempPicture,
                IMAGE_PRESETS.product
            );
            this.setState({
                tempPicture: result.previewUrl,
                picFile: result.file,
            });
        } catch (error) {
            console.error('[ProductEdit] changePicture failed', error);
            revokeImagePreviewUrl(this.state.tempPicture);
            this.setState({ picFile: null, tempPicture: "" });
            toast.error(error.message || 'Could not use that photo. Try again with a smaller image.');
        } finally {
            input.value = '';
        }
    }

    changeStock(event) {
        var curProduct = this.state.curProduct;
        curProduct.Inventory = event.target.value;
        this.setState({ curProduct: curProduct });
    }

    changeVariations(event) {
        this.setState({ isVariations: event.target.checked });
    }

    changeOptions(event) {
        this.setState({ isOptions: event.target.checked });
    }

    changeInventory(event) {
        const checked = event.target.checked;
        const curProduct = { ...this.state.curProduct, TrackInventory: checked };
        this.setState({ isInventory: checked, curProduct });
    }

    changeVariationName = (variationId, event) => {
        console.log(variationId);
        var curProduct = this.state.curProduct;
        var variations = curProduct.Variations.filter(function( v ) {
            return v.VariationId == variationId;
        });

        if (variations.length > 0) {
            variations[0].Name = event.target.value;
            this.setState({curProduct: curProduct});
        }
    }

    changeVariationCost = (variationId, event) => {
        console.log(variationId);
        var curProduct = this.state.curProduct;
        var variations = curProduct.Variations.filter(function( v ) {
            return v.VariationId == variationId;
        });

        if (variations.length > 0) {
            variations[0].Cost = event.target.value;
            this.setState({curProduct: curProduct});
        }
    }

    onClickAddVariation = (event) => {
        event.preventDefault();
        console.log(event);

        var curProduct = this.state.curProduct;
        var tempVariation = curProduct.Variations.filter(function( v ) {
            return v.VariationId == 0;
        });

        if (tempVariation.length > 0) {
            this.setState({variationError: "Please save the new variation first!"});
        } else {
            var variantion = {... mockVariation};
            curProduct.Variations.push(variantion);
            this.setState({curProduct: curProduct, variationError: ""});
        }
    }

    changeVariationInventory = (variationId, event) => {
        var curProduct = this.state.curProduct;
        var variations = curProduct.Variations.filter(function( v ) {
            return v.VariationId == variationId;
        });

        if (variations.length > 0) {
            const val = event.target.value;
            variations[0].Inventory = val === '' ? null : parseInt(val, 10);
            this.setState({curProduct: curProduct});
        }
    }

    changeVariationSku = (variationId, event) => {
        var curProduct = this.state.curProduct;
        var variations = curProduct.Variations.filter(function( v ) {
            return v.VariationId == variationId;
        });

        if (variations.length > 0) {
            variations[0].SKU = event.target.value;
            this.setState({curProduct: curProduct});
        }
    }

    changeOptionName = (optionId, event) => {
        console.log(optionId);
        var curProduct = this.state.curProduct;
        var options = curProduct.Options.filter(function( o ) {
            return o.OptionId == optionId;
        });

        if (options.length > 0) {
            options[0].Name = event.target.value;
            this.setState({curProduct: curProduct});
        }
    }

    changeOptionCost = (optionId, event) => {
        var curProduct = this.state.curProduct;
        var options = curProduct.Options.filter(function( o ) {
            return o.OptionId == optionId;
        });

        if (options.length > 0) {
            options[0].Cost = event.target.value;
            this.setState({curProduct: curProduct});
        }
    }

    changeOptionTrackInventory = (optionId, event) => {
        var curProduct = this.state.curProduct;
        var options = curProduct.Options.filter(function( o ) {
            return o.OptionId == optionId;
        });

        if (options.length > 0) {
            options[0].TrackInventory = event.target.checked;
            this.setState({curProduct: curProduct});
        }
    }

    changeOptionInventory = (optionId, event) => {
        var curProduct = this.state.curProduct;
        var options = curProduct.Options.filter(function( o ) {
            return o.OptionId == optionId;
        });

        if (options.length > 0) {
            const val = event.target.value;
            options[0].Inventory = val === '' ? 0 : parseInt(val, 10);
            this.setState({curProduct: curProduct});
        }
    }

    changeOptionSku = (optionId, event) => {
        var curProduct = this.state.curProduct;
        var options = curProduct.Options.filter(function( o ) {
            return o.OptionId == optionId;
        });

        if (options.length > 0) {
            options[0].SKU = event.target.value;
            this.setState({curProduct: curProduct});
        }
    }

    onClickAddOption = (event) => {
        var curProduct = this.state.curProduct;
        var tempOption = curProduct.Options.filter(function( o ) {
            return o.OptionId == 0;
        });

        if (tempOption.length > 0) {
            this.setState({optionError: "Please save the new option first!"});
        } else {
            var option = {... mockOption};
            curProduct.Options.push(option);
            this.setState({curProduct: curProduct, optionError: ""});
        }
    }

    onClickSaveInventory = (event) => {
        event.preventDefault();
        console.log(event);

        const {curProduct} = this.state;

        var inventoryError = "";
        if (curProduct.Inventory == "") {
            inventoryError = "Please input stock";
        }

        if (inventoryError == "") {
            this.props.dispatch(updateInventoryRequest(
                curProduct
            ))
        }
        this.setState({inventoryError: inventoryError});
    }

    getProductById = (id) => {
        const {products} = this.props;
        var data = products.filter(function( p ) {
            return p.ProductId == id;
        });

        if (data.length > 0) {
            return data[0];
        } else {
            return mockProduct;
        }
    }

    getCategoryById = (id) => {
        let category = this.props.categories.filter(function( c ) {
            return c.CategoryId == id;
        });

        if (category.length > 0) {
            return category[0]
        } else {
            return null;
        }
    }
    
    getProducts = () => {
        const {curCategoryId, products} = this.props;

        if (curCategoryId != 0) {
            var data = products.filter(function( p ) {
                return p.CategoryId == curCategoryId;
            });
    
            return data;
        } else {
            return products;
        }
    }

    goBack = () => {
        this.props.history.push('/admin/products/prod_list');
    }

    createNewProduct = () => {
        this.props.history.push('/app/ecommerce/management/create');
    }

    onClickSaveProduct = (e) => {
        e.preventDefault();

        var prodError = "";
        const {curProduct, picFile} = this.state;
        const {merchant, history} = this.props;

        console.log("curProduct");
        console.log(curProduct);

        if (curProduct.Name === "") {
            prodError = "Please input name";
        } else if (curProduct.Price === "") {
            prodError = "Please input price";
        } else if (curProduct.SKU === "") {
            prodError = "Please input SKU";
        } else if (curProduct.TaxRate === "") {
            prodError = "Please input tax rate";
        } 

        if (prodError == "") {
            if (curProduct.ProductId == 0) {
                this.props.dispatch(createProductRequest({
                    curProduct: curProduct,
                    picFile,
                    merchantId: merchant.MerchantId,
                    history
                }))
            } else {
                this.props.dispatch(updateProductRequest({
                    curProduct: {...curProduct},
                    picFile,
                    merchantId: merchant.MerchantId,
                    history
                }))
                this.props.dispatch(saveProductStripeTaxCodeRequest(curProduct.ProductId, this.state.stripeTaxCode));
            }
        }
        this.setState({prodError: prodError});
    }

    onClickSaveVariation = async (e, variationId) => {
        e.preventDefault();

        var curProduct = this.state.curProduct;
        var variations = curProduct.Variations.filter(function( v ) {
            return v.VariationId == variationId;
        });

        var variation = variations[0];

        var error = "";
        if (variation.Name == "") {
            error = "Please input name";
        } else if (variation.Cost == "") {
            error = "Please input price";
        }
        if (error == "") {
            if (variation.VariationId == 0) {
                const result = await this.props.dispatch(createVariationRequest({
                    productId: curProduct.ProductId,
                    variation
                }));

                if (result && result.seededVariation) {
                    const seededId = result.seededVariation.VariationId;
                    const alreadyPresent = curProduct.Variations.some(v => v.VariationId === seededId);
                    if (!alreadyPresent) {
                        const savedIndex = curProduct.Variations.findIndex(v => v.VariationId === result.variationId);
                        const seededRow = {
                            VariationId: result.seededVariation.VariationId,
                            Name: result.seededVariation.Name,
                            Cost: result.seededVariation.Cost,
                            Inventory: result.seededVariation.Inventory,
                            SKU: result.seededVariation.SKU || ''
                        };
                        if (savedIndex >= 0) {
                            curProduct.Variations.splice(savedIndex, 0, seededRow);
                        } else {
                            curProduct.Variations.unshift(seededRow);
                        }
                        this.setState({ curProduct: curProduct });
                    }
                }
            } else {
                this.props.dispatch(updateVariationRequest({
                    productId: curProduct.ProductId,
                    variation
                }))
            }
        } 
        this.setState({variationError: error});
    }

    onClickDeleteVariation = (e, variationId) => {
        e.preventDefault();

        var curProduct = this.state.curProduct;
        if (variationId == 0) {
            let index = curProduct.Variations.findIndex(v => v.VariationId === 0);
            curProduct.Variations.splice(index, 1);
            this.setState({curProduct: curProduct});
        } else {
            this.props.dispatch(deleteVariationRequest({
                productId: curProduct.ProductId,
                variationId
            }))
        }
    }

    onClickSaveOption = (e, optionId) => {
        e.preventDefault();

        var curProduct = this.state.curProduct;
        var options = curProduct.Options.filter(function( o ) {
            return o.OptionId == optionId;
        });
        
        var option = options[0];

        var error = "";
        if (option.Name == "") {
            error = "Please input name";
        } 
        if (error == "") {
            if (option.OptionId == 0) {
                this.props.dispatch(createOptionRequest({
                    productId: curProduct.ProductId,
                    option
                }))
            } else {
                this.props.dispatch(updateOptionRequest({
                    productId: curProduct.ProductId,
                    option
                }))
            }
        } 
        this.setState({optionError: error});
    }

    onClickDeleteOption = (e, optionId) => {
        e.preventDefault();
     
        var curProduct = this.state.curProduct;
        if (optionId == 0) {
            let indexToOption = curProduct.Options.findIndex(o => o.OptionId === 0);
            curProduct.Options.splice(indexToOption, 1);
            this.setState({curProduct: curProduct});
        } else {
            this.props.dispatch(deleteOptionRequest({
                productId: curProduct.ProductId,
                optionId
            }))
        }
    }

    render() {
       
        const {curProduct, prodError, variationError, optionError, inventoryError, tempPicture, isVariations, isOptions, isInventory} = this.state;
        const {categories, t} = this.props;
        const hasActiveVariations = (curProduct.Variations || []).length > 0;
        const variationStockTotal = (curProduct.Variations || []).reduce((sum, v) => sum + (Number(v.Inventory) || 0), 0);
        const categoryInternal = !!(categories || []).find((c) => Number(c.CategoryId) === Number(curProduct.CategoryId) && (c.InternalOnly || c.internalOnly));
        const internalChecked = categoryInternal || !!curProduct.InternalOnly;

        return (
            <div className="prod_edit">
                <div className="bg-second p-4" style={{borderRadius: 'var(--radius-md)'}}>
                    <div className={`${s.subHeader}`}>
                        <a className="back-link" href="#" onClick={this.goBack}><i className="zmdi zmdi-arrow-left"></i></a>
                        <h3 className="mt-0 mb-5 text-white">{t('productEdit.details')}</h3>
                    </div>
                    <form>
                        <div className={`row ${s.imageContainer}`}>
                            <div className="image-upload-compact">
                                <input id="img" type="file" onChange={this.changePicture} accept="image/*"/>
                                <label htmlFor="img" className="image-upload-label">
                                    {(tempPicture || curProduct.Picture) ? (
                                        <>
                                            <img src={tempPicture || curProduct.Picture} alt={t('productEdit.productAlt')} className="image-upload-preview"/>
                                            <div className="image-upload-overlay">
                                                <i className="zmdi zmdi-camera"></i>
                                                <span>{t('productEdit.change')}</span>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="image-upload-placeholder">
                                            <i className="zmdi zmdi-image-alt"></i>
                                            <span>{t('productEdit.addImage')}</span>
                                        </div>
                                    )}
                                </label>
                            </div>
                        </div>
                        <div className="row alert-container">
                        {
                            prodError && (
                                <Alert className="alert-sm" color="danger">
                                    {prodError}
                                </Alert>
                            )
                        }
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{t('productEdit.name')}</label>
                                    <input type="text" className="form-control" placeholder="" required="" value={curProduct.Name} onChange={this.changeName}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{t('productEdit.price')}</label>
                                    <input type="number" className="form-control" placeholder="" required="" value={curProduct.Price} onChange={this.changePrice}/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{this.props.t('productsTabs.category')}</label>
                                    <select className={`form-control ${s.select}`} value={curProduct.CategoryId} onChange={this.changeCategory}>
                                    {categories.map((category, i) => 
                                        <option value={category.CategoryId} key={category.CategoryId}>{category.Name}</option>
                                    )}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{t('productEdit.cardFee')}</label>
                                    <select className={`form-control ${s.select}`} value={curProduct.FeeOption} onChange={this.changeFee}>
                                    {mockFeeOptions.map((fee, i) => 
                                        <option value={fee.Id} key={fee.Id}>{fee.Name}</option>
                                    )}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>{t('productEdit.sku')}</label>
                                    <input type="text" className="form-control" placeholder="" required="" value={curProduct.SKU} onChange={this.changeSku}/>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <div className={`form-group ${s.internalOnly}`}>
                                    <label className={s.toggleRow}>
                                        <input
                                            type="checkbox"
                                            checked={internalChecked}
                                            disabled={categoryInternal}
                                            onChange={this.changeInternalOnly}
                                        />
                                        <span>{t('productEdit.internalOnly')}</span>
                                    </label>
                                    <p className={s.helpText}>
                                        {categoryInternal
                                            ? t('productEdit.internalInherited')
                                            : t('productEdit.internalHelp')}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>{t('productEdit.taxRate')}</label>
                                    <input type="number" className="form-control" placeholder="" required="" value={curProduct.TaxRate} onChange={this.changeTax}/>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>{t('productEdit.stripeTax')}</label>
                                    <select
                                        className={`form-control ${s.select}`}
                                        value={this.state.stripeTaxCode}
                                        onChange={this.changeStripeTaxCode}
                                        disabled={curProduct.ProductId == 0}
                                    >
                                        <option value="">{t('productEdit.inheritDefault', { code: this.state.stripeTaxPresets.inherit })}</option>
                                        <option value={this.state.stripeTaxPresets.food}>{t('productEdit.food', { code: this.state.stripeTaxPresets.food })}</option>
                                        <option value={this.state.stripeTaxPresets.alcohol}>{t('productEdit.alcohol', { code: this.state.stripeTaxPresets.alcohol })}</option>
                                        <option value={this.state.stripeTaxPresets.merchandise}>{t('productEdit.merchandise', { code: this.state.stripeTaxPresets.merchandise })}</option>
                                        {this.state.stripeTaxCode
                                            && this.state.stripeTaxCode !== this.state.stripeTaxPresets.food
                                            && this.state.stripeTaxCode !== this.state.stripeTaxPresets.alcohol
                                            && this.state.stripeTaxCode !== this.state.stripeTaxPresets.merchandise
                                            ? (
                                                <option value={this.state.stripeTaxCode}>{t('productEdit.custom', { code: this.state.stripeTaxCode })}</option>
                                            )
                                            : null}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>{t('productEdit.description')}</label>
                            <textarea className={`form-control ${s.textArea}`} value={curProduct.Description || ''} onChange={this.changeDescription}></textarea>
                        </div>
                        <div className={`form-group ${s.btnContainer}`}>
                            <a href="#" className="btn btn-save btn-sm mt-2" onClick={(e) => this.onClickSaveProduct(e)} >{t('productEdit.saveDetails')}</a>
                        </div>
                    </form>

                    {/* Variations, Options, and Inventory — only when editing existing product */}
                    {
                        curProduct.ProductId != 0 && (
                            <div className="mt-4">
                                {/* Variations */}
                                <div className="d-flex align-items-center px-4 mb-3 text-white py-2 switch-toolbar">
                                    {t('productEdit.addVariations')}
                                    <label className="switch ml-auto my-1">
                                        <input type="checkbox" checked={isVariations} onChange={this.changeVariations}/>
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="row alert-container">
                                {
                                    variationError && (
                                        <Alert className="alert-sm" color="danger">
                                            {variationError}
                                        </Alert>
                                    )
                                }
                                </div>
                                {
                                    isVariations && (
                                        <form className="mb-4">
                                            {curProduct.Variations.map((variation, i) => 
                                                <div key={variation.VariationId} className={s.optionRow}>
                                                    <div className={`form-group ${s.optionNameField}`}>
                                                        <label>{t('productEdit.variation')}</label>
                                                        <input type="text" className="form-control" placeholder="" required=""
                                                            value={variation.Name} onChange={(e) => this.changeVariationName(variation.VariationId, e)}/>
                                                    </div>
                                                    <div className={`form-group ${s.optionPriceField}`}>
                                                        <label>{t('productEdit.priceShort')}</label>
                                                        <input type="number" className="form-control" placeholder="" required=""
                                                            value={variation.Cost} onChange={(e) => this.changeVariationCost(variation.VariationId, e)}/>
                                                    </div>
                                                    <div className={`form-group ${s.optionStockField}`}>
                                                        <label>{t('productEdit.stock')}</label>
                                                        <input type="number" className="form-control" placeholder={t('productEdit.onHand')} min="0"
                                                            value={variation.Inventory == null ? '' : variation.Inventory}
                                                            onChange={(e) => this.changeVariationInventory(variation.VariationId, e)}/>
                                                    </div>
                                                    <div className={`form-group ${s.optionSkuField}`}>
                                                        <label>{t('productEdit.sku')}</label>
                                                        <input type="text" className="form-control" placeholder={t('common.optional')}
                                                            value={variation.SKU || ''}
                                                            onChange={(e) => this.changeVariationSku(variation.VariationId, e)}/>
                                                    </div>
                                                    <div className={`form-group variation-action ${s.optionActionField}`}>
                                                        <label>{t('common.action')}</label>
                                                        <div className="variation-button-group">
                                                            <a href="#" className="btn btn-delete btn-sm" onClick={(e) => this.onClickDeleteVariation(e, variation.VariationId)} >{t('common.delete')}</a>
                                                            <a href="#" className="btn btn-save btn-sm" onClick={(e) => this.onClickSaveVariation(e, variation.VariationId)} >{t('common.save')}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            
                                            <div>
                                                <button className="btn-outline-success" type="button" onClick={(e) => this.onClickAddVariation(e)}><i className="zmdi zmdi-plus"></i> {t('productEdit.addAnotherVariation')}</button>
                                            </div>
                                        </form>
                                    )
                                }

                                {/* Options */}
                                <div className="d-flex align-items-center px-4 mb-3 text-white py-2 switch-toolbar">
                                    {t('productEdit.addOptions')}
                                    <label className="switch ml-auto my-1">
                                        <input type="checkbox" checked={isOptions} onChange={this.changeOptions}/>
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="row alert-container">
                                {
                                    optionError && (
                                        <Alert className="alert-sm" color="danger">
                                            {optionError}
                                        </Alert>
                                    )
                                }
                                </div>
                                {
                                    isOptions && (
                                        <form className="mb-4">
                                            {curProduct.Options.map((option, i) => 
                                                <div key={option.OptionId} className={s.optionRow}>
                                                    <div className={`form-group ${s.optionNameField}`}>
                                                        <label>
                                                            {t('productEdit.option')}
                                                            {option.IsFromCategory ? (
                                                                <span className={s.fromCategoryBadge} title={t('productEdit.fromCategoryTitle')}>{t('productEdit.fromCategory')}</span>
                                                            ) : null}
                                                        </label>
                                                        <input type="text" className="form-control" placeholder="" required=""
                                                            value={option.Name} onChange={(e) => this.changeOptionName(option.OptionId, e)}/>
                                                    </div>
                                                    <div className={`form-group ${s.optionPriceField}`}>
                                                        <label>{t('productEdit.price')}</label>
                                                        <input type="number" className="form-control" placeholder="" required=""
                                                            value={option.Cost} onChange={(e) => this.changeOptionCost(option.OptionId, e)}/>
                                                    </div>
                                                    <div className={`form-group ${s.optionTrackField}`}>
                                                        <label>{t('productEdit.trackStock')}</label>
                                                        <div className={s.optionTrackToggle}>
                                                            <input type="checkbox" checked={!!option.TrackInventory} onChange={(e) => this.changeOptionTrackInventory(option.OptionId, e)}/>
                                                            <span>{option.TrackInventory ? t('productEdit.on') : t('productEdit.off')}</span>
                                                        </div>
                                                    </div>
                                                    <div className={`form-group ${s.optionStockField}`}>
                                                        <label>{t('productEdit.stock')}</label>
                                                        <input type="number" className="form-control" placeholder={t('productEdit.onHand')} min="0"
                                                            disabled={!option.TrackInventory}
                                                            value={option.Inventory || 0}
                                                            onChange={(e) => this.changeOptionInventory(option.OptionId, e)}/>
                                                    </div>
                                                    <div className={`form-group ${s.optionSkuField}`}>
                                                        <label>{t('productEdit.sku')}</label>
                                                        <input type="text" className="form-control" placeholder={t('common.optional')}
                                                            disabled={!option.TrackInventory}
                                                            value={option.SKU || ''}
                                                            onChange={(e) => this.changeOptionSku(option.OptionId, e)}/>
                                                    </div>
                                                    <div className={`form-group variation-action ${s.optionActionField}`}>
                                                        <label>{t('common.action')}</label>
                                                        <div className="variation-button-group">
                                                            <a href="#" className="btn btn-delete btn-sm" onClick={(e) => this.onClickDeleteOption(e, option.OptionId)} >{option.IsFromCategory ? t('productEdit.remove') : t('common.delete')}</a>
                                                            <a href="#" className="btn btn-save btn-sm" onClick={(e) => this.onClickSaveOption(e, option.OptionId)} >{t('common.save')}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <div>
                                                <button className="btn-outline-success" type="button" onClick={(e) => this.onClickAddOption(e)}><i className="zmdi zmdi-plus"></i> {t('productEdit.addAnotherOption')}</button>
                                            </div>
                                        </form>
                                    )
                                }

                                {/* Inventory */}
                                <div className="d-flex align-items-center px-4 mb-3 text-white py-2 switch-toolbar">
                                    {t('productEdit.manageInventory')}
                                    <label className="switch ml-auto my-1">
                                        <input type="checkbox" checked={isInventory} onChange={this.changeInventory}/>
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="row alert-container">
                                {
                                    inventoryError && (
                                        <Alert className="alert-sm" color="danger">
                                            {inventoryError}
                                        </Alert>
                                    )
                                }
                                </div>
                                {
                                    isInventory && (
                                        <form className="mb-4">
                                            {hasActiveVariations ? (
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <p className="text-white mb-0">{t('productEdit.totalStock')} <strong>{variationStockTotal}</strong></p>
                                                        <p className="text-white-50 mb-0" style={{fontSize: '0.85rem'}}>{t('productEdit.variationStockHelp')}</p>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <input type="number" className="form-control" placeholder={t('productEdit.availableStock')} required="" value={curProduct.Inventory} onChange={this.changeStock}/>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <a href="#" className="btn btn-save btn-sm" onClick={(e) => this.onClickSaveInventory(e)}>{t('productEdit.saveInventory')}</a>
                                                    </div>
                                                </div>
                                            )}
                                        </form>
                                    )
                                }
                            </div>
                        )
                    }
                </div>   
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        //products: getProductsByCategoryId(state),
        products: state.products.data,
        categories: state.products.categories,
        curCategoryId: state.products.curCategoryId,
        curProductId: state.products.curProductId,
        merchant: state.auth.merchant,
        productDefaults: state.settings.productDefaults,
        isReceiving: state.products.isReceiving,
        isUpdating: state.products.isUpdating,
        error: state.products.error,
        isDeleting: state.products.isDeleting,
        idToDelete: state.products.idToDelete,
    };
}

export default withRouter(connect(mapStateToProps)(withTranslation(ProductEdit)));

